let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k1740")).then(() => parcelRequire('bnnuC'));